import Vue from 'vue'

export default Vue.directive('facebook-signin-button', {
    bind: function (el, binding, vnode) {
        if (!vnode.context.onFacebookConnected) {
            throw new Error('The method onFacebookConnected must be defined on the component')
        }

        if (!vnode.context.onFacebookError) {
            throw new Error('The method onFacebookError must be defined on the component')
        }
        initFacebook();
        loadFacebookSDK(document, "script", "facebook-jssdk");

        let appId = binding.value

        el.addEventListener('click', initiateFacebookLogin);

        async function  initiateFacebookLogin() {
            window.FB.getLoginStatus(function(response) {
                if(response.status === 'connected' && response.authResponse) {
                    vnode.context.onFacebookConnected(response.authResponse);
                } else {
                    logInWithFacebook();
                }
            });
        }

        async function logInWithFacebook() {
            window.FB.login(function(response) {
                if (response.status === 'connected' && response.authResponse) {
                    vnode.context.onFacebookConnected(response.authResponse);
                } else {
                    vnode.context.onFacebookError(response.status);
                }
            }, { scope: 'public_profile,email'});
            return false;
        }
        async function initFacebook() {
            window.fbAsyncInit = function() {
                window.FB.init({
                    appId: appId,
                    cookie: true,
                    status: true,
                    autoLogAppEvents : true,
                    xfbml: false,
                    version: "v7.0"
                });
            };
        }
        async function loadFacebookSDK(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }
    }
})
